import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Box,
  Button,
  Divider,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Paper,
  Typography,
} from '@mui/material';

import { updatePassword } from '../../actions/userActions';

function handleMouseDownPassword(event: React.MouseEvent<HTMLButtonElement>) {
  event.preventDefault();
}

type Props = ResolveThunks<typeof actionCreators>;

interface State {
  readonly password: string;
  readonly repeat: string;
  readonly error: string | null;
  readonly showPassword?: boolean;
}

const initialState: State = {
  password: '',
  repeat: '',
  error: null,
};

class ChangePassword extends React.Component<Props, State> {
  state = initialState;

  onApplyClick = () => {
    if (
      this.state.password.length === 0 ||
      this.state.repeat.length === 0 ||
      this.state.password !== this.state.repeat
    ) {
      this.setState({ error: 'Incorrect Values' });
    } else {
      this.props.updatePassword(this.state.password);
      this.setState(initialState);
    }
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  renderError() {
    if (this.state.error)
      return (
        <Typography variant="body2" color="error">
          {this.state.error}
        </Typography>
      );
    return null;
  }

  render() {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: '35%', p: 1 }}>
        <Typography variant="h6">Change Password</Typography>
        <Divider sx={{ mb: 4 }} />
        <Paper
          sx={{
            p: 2,
            pt: 0,
            bgcolor: 'backContrast.main',
            display: 'flex',
            flexDirection: 'column',
          }}
          elevation={1}
        >
          {this.renderError()}
          <FormControl variant="standard" sx={{ my: 1, mx: 0 }}>
            <InputLabel htmlFor="adornment-password">New Password</InputLabel>
            <Input
              autoFocus={false}
              id="adornment-password"
              type={this.state.showPassword ? 'text' : 'password'}
              value={this.state.password}
              onChange={(event) => {
                this.setState({ password: event.target.value });
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl variant="standard" sx={{ my: 1, mx: 0 }}>
            <InputLabel htmlFor="adornment-password-reenter">Re-enter Password</InputLabel>
            <Input
              id="adornment-password-reenter"
              type={this.state.showPassword ? 'text' : 'password'}
              onChange={(event) => {
                this.setState({ repeat: event.target.value });
              }}
              value={this.state.repeat}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Paper>
        <Button
          variant="contained"
          sx={{
            mt: 3,
            mb: 1,
            py: 1,
            width: 150,
            color: 'buttonColor.main',
            bgcolor: 'backContrast.main',
            '&:hover': {
              bgcolor: 'primary.dark',
              color: '#fff',
            },
          }}
          onClick={this.onApplyClick}
        >
          Apply
        </Button>
      </Box>
    );
  }
}

const actionCreators = {
  updatePassword,
};

export default connect(null, actionCreators)(ChangePassword);
